export default function CircularLoading({ colour, addYMargin }) {
	return (
		<div
			className={`tw-h-full tw-w-full tw-flex tw-items-center tw-justify-center ${
				addYMargin && 'tw-mt-40 tw-mb-5'
			}`}>
			<svg
				className='tw-animate-spin tw-border-[5px] tw-border-white/30 tw-border-t-blue-600 tw-border-solid tw-rounded-full tw-w-12 tw-mr-3'
				style={{ borderTopColor: colour }}
				viewBox='0 0 48 48'></svg>
		</div>
	);
}
